import React from 'react';
import { Flex } from './hocs/withStyles';

const Maintenance = () =>
  <Flex p={[2]} direction="column">
    <Flex>
      <strong>Maitenance Mode</strong>
    </Flex>
    <Flex>
      We are working on some upgrades!<br />
      Kairos will be back shortly with some sunny destinations...
    </Flex>
  </Flex>;

export default Maintenance;



// WEBPACK FOOTER //
// ./src/components/Maintenance.js